import React from 'react';
import StatusBadge, { StatusVariant } from './StatusBadge';

interface EntityHeaderProps {
  title: string;
  statusVariant: StatusVariant;
  statusText?: string;
  metadata: Array<{
    label: string;
    value?: string | null;
    show?: boolean;
  }>;
  className?: string;
}

const EntityHeader: React.FC<EntityHeaderProps> = ({
  title,
  statusVariant,
  statusText,
  metadata,
  className = '',
}) => {
  const visibleMetadata = metadata.filter(
    (item) => item.show !== false && item.value
  );

  return (
    <div
      className={`flex flex-col md:flex-row md:items-center md:justify-between mb-4 md:mb-6 space-y-3 md:space-y-0 ${className}`}
    >
      <div className="flex items-center space-x-3 min-w-0 flex-1">
        <h2 className="text-xl md:text-2xl font-semibold text-gray-900 dark:text-gray-100 truncate min-w-0 flex-1">
          {title}
        </h2>
        <StatusBadge variant={statusVariant}>
          {statusText ||
            statusVariant.charAt(0).toUpperCase() + statusVariant.slice(1)}
        </StatusBadge>
      </div>

      {visibleMetadata.length > 0 && (
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs md:text-sm text-gray-500 dark:text-gray-400 md:ml-6">
          {visibleMetadata.map((item, index) => (
            <React.Fragment key={item.label}>
              {index > 0 && <span className="hidden sm:inline">•</span>}
              <span>{item.value}</span>
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

export default EntityHeader;
